var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { imageBaseUrl } from '../utils/variables';
import { useState } from 'react';
import Snackbar from '../snackBar';
var CopyToClipBoard = function (props) {
    var _a = useState(false), isCopied = _a[0], setIsCopied = _a[1];
    return (React.createElement("div", { className: "copy-to-clipboard", onClick: function () {
            navigator['clipboard'].writeText(props.text);
            props.onCopy && props.onCopy(props.text);
            setIsCopied(true);
        }, style: __assign({}, props.style), title: "Copy to Clipboard" },
        props.children,
        React.createElement("img", { width: "25px", height: "25px", title: "Copy to Clipboard", style: { cursor: "pointer" }, alt: "Copy", src: "".concat(imageBaseUrl, "/img/icons/copy-clipboard-icon.png"), onClick: function () { navigator.clipboard.writeText(props.text); props.onCopy && props.onCopy(props.text); } }),
        React.createElement(Snackbar, { show: isCopied, timeout: 1000, onCloseHandler: function (show) { return setIsCopied(show); } },
            React.createElement("p", null, "Copied to Clipboard"))));
};
export default CopyToClipBoard;
//# sourceMappingURL=index.js.map